// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.event-section .event-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  position: relative;
}
.event-section .event-wrap .img-box {
  width: 100%;
  max-width: 25.625rem;
  border-bottom-left-radius: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
  transform: scale(1.075) translateY(2px);
  transform-origin: left bottom;
}
.event-section .event-wrap .img-box img {
  width: 100%;
  max-width: 100%;
  height: auto;
}
.event-section .event-wrap .text-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  padding: 3rem 2rem 2rem;
}
.event-section .event-wrap .text-box .subtitle-text {
  font-family: "TiltWarp", sans-serif;
  color: var(--white-1000);
  font-size: 2.25rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
}
.event-section .event-wrap .text-box img {
  width: 100%;
  max-width: 24.75rem;
  height: auto;
  margin: auto;
}
.event-section .event-wrap .event-text-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 2rem;
}
.event-section .event-wrap .event-text-box .date-text {
  font-family: "TiltWarp", sans-serif;
  color: var(--white-1000);
  font-size: 5.375rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
}
.event-section .event-wrap .event-text-box .month-text {
  font-family: "TiltWarp", sans-serif;
  color: var(--white-1000);
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
}
.event-section .event-wrap .event-text-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.event-section .event-container {
  width: 100%;
  max-width: var(--containerWidth);
  min-height: 19rem;
  display: flex;
  align-items: center;
  z-index: 0;
  margin: 0 auto;
  position: relative;
}
.event-section .event-container::before {
  content: "";
  width: 100%;
  height: 100%;
  background: linear-gradient(175deg, var(--primaryMain-1000) 4%, var(--tertiaryMain-1000) 96%);
  border-radius: 3.75rem;
  z-index: -1;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
@media screen and (max-width: 991.98px) {
  .event-section {
    padding: 2.5rem 0;
  }
  .event-section .event-wrap {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .event-section .event-wrap .img-box {
    border-bottom-left-radius: 1.5rem;
    grid-row-start: 2;
    grid-row-end: 3;
    transform: scale(0.85) translateY(2px);
  }
  .event-section .event-wrap .text-box {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 3;
    gap: 1.5rem;
    padding: 1.5rem;
  }
  .event-section .event-wrap .event-text-box {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 2;
    grid-column-end: 3;
    padding: 1.5rem;
  }
  .event-section .event-container {
    min-height: unset;
  }
  .event-section .event-container::before {
    border-radius: 1.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .event-section {
    padding: 2rem 0;
  }
  .event-section .event-wrap {
    grid-template-columns: repeat(1, 1fr);
  }
  .event-section .event-wrap .img-box {
    max-width: 75%;
    border-bottom-left-radius: 1rem;
    opacity: 0.2;
    z-index: -1;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .event-section .event-wrap .text-box {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 2;
  }
  .event-section .event-wrap .text-box img {
    max-width: 15rem;
  }
  .event-section .event-wrap .event-text-box {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 2;
  }
  .event-section .event-container::before {
    border-radius: 1rem;
  }
}
@media screen and (max-width: 639.98px) {
  .event-section {
    padding: 2rem 0;
  }
  .event-section .event-wrap .text-box .subtitle-text {
    font-size: 2rem;
  }
  .event-section .event-wrap .text-box img {
    max-width: 10rem;
  }
  .event-section .event-wrap .event-text-box .date-text {
    font-size: 4rem;
  }
  .event-section .event-wrap .event-text-box .month-text {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/EventSection/EventStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;AACJ;AACI;EACE,WAAA;EACA,oBAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uCAAA;EACA,6BAAA;AACN;AACM;EACE,WAAA;EACA,eAAA;EACA,YAAA;AACR;AAGI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AADN;AAGM;EACE,mCAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AADR;AAIM;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAFR;AAMI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AAJN;AAMM;EACE,mCAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAJR;AAOM;EACE,mCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AALR;AAQM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AANR;AAWE;EACE,WAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AATJ;AAWI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,6FAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;AATN;AAaE;EAhHF;IAiHI,iBAAA;EAVF;EAYE;IACE,aAAA;IACA,qCAAA;EAVJ;EAYI;IACE,iCAAA;IACA,iBAAA;IACA,eAAA;IACA,sCAAA;EAVN;EAaI;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EAXN;EAcI;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;IACA,eAAA;EAZN;EAgBE;IACE,iBAAA;EAdJ;EAgBI;IACE,qBAAA;EAdN;AACF;AAkBE;EAzJF;IA0JI,eAAA;EAfF;EAiBE;IACE,qCAAA;EAfJ;EAiBI;IACE,cAAA;IACA,+BAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,OAAA;IACA,SAAA;EAfN;EAkBI;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;EAhBN;EAkBM;IACE,gBAAA;EAhBR;EAoBI;IACE,iBAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;EAlBN;EAuBI;IACE,mBAAA;EArBN;AACF;AAyBE;EAnMF;IAoMI,eAAA;EAtBF;EA0BM;IACE,eAAA;EAxBR;EA2BM;IACE,gBAAA;EAzBR;EA8BM;IACE,eAAA;EA5BR;EA+BM;IACE,iBAAA;EA7BR;AACF","sourcesContent":[".event-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .event-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    display: flex;\n    justify-content: space-between;\n    margin: 0 auto;\n    position: relative;\n\n    .img-box {\n      width: 100%;\n      max-width: 25.625rem;\n      border-bottom-left-radius: 3.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: flex-end;\n      overflow: hidden;\n      transform: scale(1.075) translateY(2px);\n      transform-origin: left bottom;\n\n      img {\n        width: 100%;\n        max-width: 100%;\n        height: auto;\n      }\n    }\n\n    .text-box {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-direction: column;\n      gap: 2rem;\n      padding: 3rem 2rem 2rem;\n      \n      .subtitle-text {\n        font-family: \"TiltWarp\", sans-serif;\n        color: var(--white-1000);\n        font-size: 2.25rem;\n        font-weight: 400;\n        line-height: 1.4;\n        text-align: center;\n      }\n\n      img {\n        width: 100%;\n        max-width: 24.75rem;\n        height: auto;\n        margin: auto;\n      }\n    }\n\n    .event-text-box {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      flex-direction: column;\n      padding: 2rem;\n\n      .date-text {\n        font-family: \"TiltWarp\", sans-serif;\n        color: var(--white-1000);\n        font-size: 5.375rem;\n        font-weight: 400;\n        line-height: 1.4;\n        text-align: center;\n      }\n\n      .month-text {\n        font-family: \"TiltWarp\", sans-serif;\n        color: var(--white-1000);\n        font-size: 2rem;\n        font-weight: 400;\n        line-height: 1.4;\n        text-align: center;\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 1rem;\n      }\n    }\n  }\n\n  .event-container {\n    width: 100%;\n    max-width: var(--containerWidth);\n    min-height: 19rem;\n    display: flex;\n    align-items: center;\n    z-index: 0;\n    margin: 0 auto;\n    position: relative;\n    \n    &::before {\n      content: \"\";\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(175deg, var(--primaryMain-1000) 4%, var(--tertiaryMain-1000) 96% );\n      border-radius: 3.75rem;\n      z-index: -1;\n      position: absolute;\n      top: 50%;\n      left: 0;\n      transform: translateY(-50%);\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .event-wrap {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n\n      .img-box {\n        border-bottom-left-radius: 1.5rem;\n        grid-row-start: 2;\n        grid-row-end: 3;\n        transform: scale(0.85) translateY(2px);\n      }\n\n      .text-box {\n        grid-row-start: 1;\n        grid-row-end: 2;\n        grid-column-start: 1;\n        grid-column-end: 3;\n        gap: 1.5rem;\n        padding: 1.5rem;\n      }\n      \n      .event-text-box {\n        grid-row-start: 2;\n        grid-row-end: 3;\n        grid-column-start: 2;\n        grid-column-end: 3;\n        padding: 1.5rem;\n      }\n    }\n\n    .event-container {\n      min-height: unset;\n      \n      &::before {\n        border-radius: 1.5rem;\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .event-wrap {\n      grid-template-columns: repeat(1, 1fr);\n\n      .img-box {\n        max-width: 75%;\n        border-bottom-left-radius: 1rem;\n        opacity: 0.2;\n        z-index: -1;\n        position: absolute;\n        left: 0;\n        bottom: 0;\n      }\n\n      .text-box {\n        grid-row-start: 1;\n        grid-row-end: 2;\n        grid-column-start: 1;\n        grid-column-end: 2;\n\n        img {\n          max-width: 15rem;\n        }\n      }\n      \n      .event-text-box {\n        grid-row-start: 2;\n        grid-row-end: 3;\n        grid-column-start: 1;\n        grid-column-end: 2;\n      }\n    }\n\n    .event-container {      \n      &::before {\n        border-radius: 1rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .event-wrap {\n      .text-box {        \n        .subtitle-text {\n          font-size: 2rem;\n        }\n\n        img {\n          max-width: 10rem;\n        }\n      }\n\n      .event-text-box {  \n        .date-text {\n          font-size: 4rem;\n        }\n  \n        .month-text {\n          font-size: 1.5rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
